var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconContactUsActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.264 3C8.494 3.008 3.008 8.494 3 15.264V24.9a2.628 2.628 0 0 0 2.628 2.628h3.504a.876.876 0 0 0 .876-.876v-8.76a.876.876 0 0 0-.876-.876H5.628c-.3.003-.596.058-.876.162v-1.914c0-5.806 4.706-10.512 10.512-10.512s10.512 4.706 10.512 10.512v1.914a2.599 2.599 0 0 0-.876-.162h-3.504a.876.876 0 0 0-.876.876v8.76c0 .484.392.876.876.876H24.9a2.628 2.628 0 0 0 2.628-2.628v-9.636C27.52 8.494 22.034 3.008 15.264 3z",
    fill: "#038AB7",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconContactUsActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-contact-us-active.9386946b811d2ace217a920d162ba6e2.svg";